export const avLibraryMessagesEn = {
  'avLibrary.pageTitle': 'Variables',
  'avLibrary.columns.name': 'Name',
  'avLibrary.columns.format': 'Format',
  'avLibrary.columns.owner': 'Owner',
  'avLibrary.columns.organization': 'Organization',
  'avLibrary.columns.updatedAt': 'Last modified',
  'avLibrary.empty': 'No analytical variables available. Create one to get started.',
};
